import { Vector3 as s, Line3 as d } from "three";
function y(e, r, n) {
  e = Array.isArray(e) ? new s(...e) : e.clone();
  const t = r.map((o) => Array.isArray(o) ? new s(...o) : o.clone());
  n !== void 0 && (e.setComponent(n, 0), t[0].setComponent(n, 0), t[1].setComponent(n, 0));
  const c = new d(...t).closestPointToPoint(e, !0, new s()), a = c.distanceTo(e);
  return { closest: c, distance: a };
}
export {
  y as distanceToLine
};
//# sourceMappingURL=index18.js.map
